<ng-template appChallengeView></ng-template>